var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    class: {
      "law-dialog-wrapper": _vm.visible
    }
  }, [_c("van-popup", {
    style: {
      width: "calc(100vw - 32px)",
      height: "95%",
      "z-index": "3006"
    },
    attrs: {
      round: "",
      closeable: ""
    },
    on: {
      close: _vm.handleClose
    },
    model: {
      value: _vm.visible,
      callback: function callback($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("div", {
    staticClass: "law-title"
  }, [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.lawIdList.length > 1,
      expression: "lawIdList.length > 1"
    }],
    on: {
      click: _vm.previous
    }
  }, [_c("svg-icon", {
    attrs: {
      name: "pre"
    }
  }), _vm._v(" 返回")], 1)]), _c("div", {
    staticClass: "law-content"
  }, [_c("div", [_vm._v(_vm._s(_vm.lawInfo["title"]))]), _c("div", {
    staticClass: "law-attr"
  }, [_c("div", {
    staticClass: "law-attr-item"
  }, [_c("div", {
    staticClass: "law-attr-label"
  }, [_vm._v("发文机关：")]), _c("div", [_vm._v(_vm._s(_vm.lawInfo["pubOffice"]))])]), _c("div", {
    staticClass: "law-attr-item"
  }, [_c("div", {
    staticClass: "law-attr-label"
  }, [_vm._v("发文字号：")]), _c("div", {
    domProps: {
      innerHTML: _vm._s(_vm.lawInfo["docNum"])
    }
  })]), _c("div", {
    staticClass: "law-attr-item"
  }, [_c("div", {
    staticClass: "law-attr-label"
  }, [_vm._v("发布日期：")]), _c("div", [_vm._v(_vm._s(_vm.lawInfo["releaseDate"]))])]), _c("div", {
    staticClass: "law-attr-item"
  }, [_c("div", {
    staticClass: "law-attr-label"
  }, [_vm._v("法规时效：")]), _c("div", [_vm._v(_vm._s(_vm.lawInfo["status"]))])])]), _c("div", {
    domProps: {
      innerHTML: _vm._s(_vm.lawInfo.content)
    }
  })])])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };